import React from 'react';

class InAppBrowser extends React.Component {
  // Static method
  static open(url, options = {}) {
    if (typeof window !== undefined) {
      window.location.href = url;
    }
  }

  render() {
    return <></>;
  }
}

export { InAppBrowser };
